export default {
      id: "ic_block_user-usage",
      viewBox: "0 0 24 25",
      url: "/" + "images/icons.3.109.2.svg#ic_block_user-usage",
      toString: function () {
        return this.url;
      }
    }